export default class extends HTMLElement {
  connectedCallback () {
    this.folderInput = document.getElementById(this.dataset.folderId)
    this.nameInput = document.getElementById(this.dataset.nameId)

    if (!this.folderInput || !this.nameInput) return

    this.onFolderChange = () => this.updateName()
    this.folderInput.addEventListener('change', this.onFolderChange)

    this.updateName()
  }

  disconnectedCallback () {
    if (this.folderInput && this.onFolderChange) {
      this.folderInput.removeEventListener('change', this.onFolderChange)
    }
  }

  updateName () {
    const folder = (this.folderInput.value || '').trim()
    const baseName = this.dataset.baseName || ''
    const defaultFolder = this.dataset.defaultFolder || 'Default'
    const cloneSuffix = this.dataset.cloneSuffix || ' (Clone)'

    if (!folder || folder === defaultFolder) {
      this.nameInput.value = baseName + cloneSuffix
    } else {
      const parts = folder.split(' / ')
      const lastPart = parts[parts.length - 1].trim()
      this.nameInput.value = lastPart + ' ' + baseName
    }
  }
}
